import * as Types from '../../../../../../../admin/graphql/src/lib/types';

import { InferenceStream } from '@wm-front/core'
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type FetchBuildingFromDeviceIdQueryVariables = Types.Exact<{
  whereInput?: Types.InputMaybe<Types.RootWhereInput>;
}>;


export type FetchBuildingFromDeviceIdQuery = { __typename?: 'Query', result: Array<{ __typename?: 'Result', building: { __typename?: 'BuildingMembers', id?: string | null } }> };

export const FetchBuildingFromDeviceIdDocument = gql`
    query FetchBuildingFromDeviceId($whereInput: RootWhereInput) {
  result: cube(where: $whereInput, limit: 1000, offset: 0) {
    building {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchBuildingFromDeviceIdGQL extends Apollo.Query<FetchBuildingFromDeviceIdQuery, FetchBuildingFromDeviceIdQueryVariables> {
    override document = FetchBuildingFromDeviceIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }